"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _Transfer = _interopRequireDefault(require("@/components/Transfer"));
var _billButtons = _interopRequireDefault(require("@/views/userCenter/componens/billButtons.vue"));
var _index = _interopRequireDefault(require("@/components/filterColumn/index.vue"));
var _index2 = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _utils = require("@/utils");
var _monthCostManagementJP = require("@/api/monthCostManagementJP/monthCostManagementJP");
var _monthButtons = _interopRequireDefault(require("@/views/settlementManagement/monthCostManagementJP/component/monthButtons.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "",
  components: {
    MonthButtons: _monthButtons.default,
    filterColumn: _index.default,
    billButtons: _billButtons.default,
    Pagination: _index2.default,
    Transfer: _Transfer.default
  },
  data: function data() {
    return {
      targetData: [],
      transferDialogVisible: false,
      loading: null,
      tableCostData: [],
      tableListNY: [{
        value: '0',
        label: 'N'
      }, {
        value: '1',
        label: 'Y'
      }],
      tableFormNY: [{
        value: '1',
        label: 'YES'
      }, {
        value: '0',
        label: 'NO'
      }],
      sourceData: [],
      targetDataOne: [],
      hotSettings: {
        dragCheck: true,
        height: '500',
        width: 'auto',
        stretchH: 'all',
        manualColumnResize: true,
        language: 'zh-CN',
        licenseKey: '8a4e2-659ac-afa83-14d2e-cb603',
        readOnly: true,
        columnSorting: true,
        showSelection: true,
        fixedColumnsLeft: 1,
        autoColumnSize: true,
        fragmentSelection: 'cell',
        copyPaste: false
      },
      listQuery: {
        currentPage: 1,
        pageSize: 20,
        total: 0
      },
      tableKey: 0,
      tableItemForm: {},
      doLessVisible: false,
      dialogTableData: []
    };
  },
  created: function created() {
    this.initData();
  },
  mounted: function mounted() {
    // console.log('   this.searchForm',   this.searchForm)
    // //  this.searchFormData()
    this.searchForm = JSON.parse(this.$route.query.searchForm);
  },
  methods: {
    doLessCLick: function doLessCLick() {
      if (this.dialogTableData.length > 1) {
        this.$message({
          message: 'Please check a record!',
          type: 'warning'
        });
        return;
      }
      this.tableItemForm = this.dialogTableData[0];
      this.doLessVisible = true;
    },
    submitForm: function submitForm() {
      var _this = this;
      var params = {
        bookingHeadId: this.tableItemForm.bookingHeadId,
        status: this.tableItemForm.doLess,
        releaseTo: this.tableItemForm.releaseTo
      };
      (0, _monthCostManagementJP.updateDoLessByBkId)(params).then(function (res) {
        console.log('res', res);
        _this.doLessVisible = false;
        _this.searchFormData();
      }).catch(function (err) {});
    },
    handlePath: function handlePath() {},
    initData: function initData() {
      var _this2 = this;
      this.sourceData = [{
        data: 'eta',
        title: 'ETA'
      }, {
        data: 'vesselName',
        title: 'VESSEL'
      }, {
        data: 'voyageNo',
        title: 'VOY'
      }, {
        data: 'blNo',
        title: 'B/L NO',
        isMonthButtons: true
      }, {
        data: 'pol',
        title: 'POL'
      }, {
        data: 'pod',
        title: 'POD'
      }, {
        data: 'usd',
        title: 'USD'
      }, {
        data: 'jpy',
        title: 'JPY'
      }, {
        data: 'agn',
        title: 'AGN',
        hasFilter: true,
        filterList: this.tableListNY
      }, {
        data: 'cst',
        title: 'CST',
        hasFilter: true,
        filterList: this.tableListNY
      }, {
        data: 'sit',
        title: 'SIT',
        hasFilter: true,
        filterList: this.tableListNY
      }, {
        data: 'doLess',
        title: 'D/O LESS',
        hasFilter: true,
        filterList: this.tableListNY
      }, {
        data: 'releaseTo',
        title: 'RELEASE TO'
      }];
      this.targetDataOne = [{
        data: 'creditVoId',
        title: 'creditVOID'
      }, {
        data: 'customer',
        title: 'customer'
      }, {
        data: 'bookingHeadId',
        title: 'bookingHeadId'
      }, {
        data: 'status',
        title: 'status'
      }, {
        data: 'agent',
        title: 'agent'
      }, {
        data: 'creditCurrency',
        title: 'creditCurrency'
      }];
      this.tableKey += 1;
      this.$nextTick(function () {
        _this2.searchFormData();
      });
      this.$refs.transfer && this.$refs.transfer.initData(this.sourceData, this.targetDataOne);
    },
    handleSortOpen: function handleSortOpen() {
      console.log('this.sourceData', this.sourceData);
      this.transferDialogVisible = true;
    },
    handleSubimtSort: function handleSubimtSort(data) {
      console.log('data', data);
      this.transferDialogVisible = false;
      this.sourceData = data;
      this.tableKey += 1;
      this.searchFormData();
      // this.$nextTick(() => {
      //   if (this.$refs.hotTableCost) {
      //     console.log('data22',this.$refs.hotTableCost)
      //     this.$refs.hotTableCost.hotInstance.render(); // 调用表格实例的 render 方法
      //   }
      // });
    },
    confirmData: function confirmData() {
      var _this3 = this;
      var data = this.$refs.hotTableCost.getSelections();
      if (data.length < 1) {
        this.$message({
          message: this.$t('home.warning'),
          type: 'warning'
        });
        return;
      }
      data.forEach(function (e) {
        delete e.$$check;
      });
      (0, _monthCostManagementJP.confirmEmail)(data).then(function (res) {
        console.log('res', res);
        _this3.searchFormData();
      }).catch(function (err) {});
    },
    backPage: function backPage() {
      this.$router.push({
        path: '/settlementManagement/monthCostManagementJP'
      });
    },
    exportFile: function exportFile() {
      var searchForm = Object.assign({}, this.searchForm);
      searchForm.pageSize = this.listQuery.total;
      (0, _monthCostManagementJP.getExport)(searchForm).then(function (res) {
        var url = window.URL.createObjectURL(new Blob([res], {
          type: 'application/x-execl'
        }));
        var link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.setAttribute('download', 'file.xlsx');
        // link.setAttribute('download', 'XXX.xlsx')
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }).catch(function (err) {
        console.log('err', err);
      });
    },
    searchFormData: function searchFormData() {
      var _this4 = this;
      var data = this.searchForm;
      data.currentPage = this.listQuery.currentPage;
      data.pageSize = this.listQuery.pageSize;
      this.loading = (0, _utils.load)();
      (0, _monthCostManagementJP.getQueryListCrdit)(data).then(function (res) {
        _this4.tableCostData = res.data.records;
        _this4.listQuery.total = res.data.totalRecord;
      }).catch(function (err) {}).finally(function () {
        _this4.loading.close();
      });
    },
    hotTableSelect: function hotTableSelect(data) {
      var array = [];
      var arrayStatus = [];
      this.$refs.hotTableCost.getSelections().forEach(function (e) {
        array.push(e.blConsigneeCertificationId);
        arrayStatus.push({
          status: e.status
        });
      });
      this.selectionIds = array;
      this.tableDataStutus = arrayStatus;
      this.dialogTableData = JSON.parse(JSON.stringify(this.$refs.hotTableCost.getSelections()));
    },
    getDetailsData: function getDetailsData(row) {
      var data = this.$refs.hotTableCost.getSelected();
      console.log('data', data);
      this.$router.push({
        path: '/settlementManagement/monthCostManagementJPDetail',
        query: {
          tableData: data,
          searchForm: this.searchForm
        }
      });
    }
  }
};